// Grundstoff
export const BASIC_MATERIAL = 1;
